import axios from 'axios';
import { getApiClientFront, getApiClientBack } from "../api/api";

// const apiUrlMap = {
//     // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
//     "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi/apibopiweb",
//     "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
//     "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",
//     "defaultApiUrl": "Error",
//     "localhost": "http://localhost:5000",
// };

// const api = axios.create({
//     // baseURL: "http://localhost:8080/BopiWeb"
//     baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
// });

export const getVisorPdfUrl = async (id) => {
    const api = await getApiClientBack();
    return `${api.defaults.baseURL}/visorPdf?id=${id}`;
};

export const getVisorPdfUrlAvanzarRetroceder = async (id) => {
    const api = await getApiClientBack();
    return `${api.defaults.baseURL}/visorPdfAvanzarRetroceder?id=${id}`;
};

export const getVisorPdfInfo = async (id) => {
    try {
        const api = await getApiClientBack();
        const response = await api.get(`/visorPdfInfo?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("❌ Error obteniendo visorPdfInfo:", error);
        return null;
    }
};